(function LivePlannerSchedule($, Adzuki)
{
	'use strict';

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/LivePlanner/schedule/', function onload() {
			// open the summary for an LP session
			$('.lp-session').on('click', function _showSummary(e) {
				var lp_session_id = $(this).data('lp-session');
				var client_id     = $(this).data('client-id');
				var $modal        = $('#modalWindow');

				e.preventDefault();

				$modal.find('.modal-body').html('<i class="'+Adzuki.FaIcon.getIconStyle('spinner')+' fa-spin fa-2x"></i>&nbsp;Loading LivePlanner summary...');
				$modal.find('.modal-title').text('LivePlanner Summary Preview');
				$modal.modal('show');

				Adzuki.Ajax.get('/LivePlanner/summary/' + lp_session_id + '/' + client_id)
				.then(function showDetails(response) {
					let content = '<iframe src="' + response + '" style="width: 100%; height: 800px;"></iframe>';
					$modal.find('.modal-body').html(content);
				});
			});

			// qtips for additional information on some appointments
			Adzuki.QTip.attachQtip('.qtip-schedule-link', undefined, undefined, 'left');

			// callback to ask agent if he/she wants to re-send the confirmation email(s)
			Adzuki.Sidebar.ajaxCallback = sidebarCallback;
		});

		Adzuki.onload('/LivePlanner/consultationRequests/', function onload() {
			// qtips for additional information on some consultation requests
			Adzuki.QTip.attachQtip('.qtip-request-link', undefined, undefined, 'left');
		});
	});

	// callback for the sidebar when the AJAX request is done
	function sidebarCallback() {
		$('.set-primary-participant-btn').off().on('click', function setPrimary(e) {
			var appointment_id  = $(this).data('appointment-id');
			var client_id       = $(this).data('client-id');
			var client_name     = $(this).data('client-name');
			var participant_url = '/LivePlanner/setPrimaryParticipant/';

			participant_url += appointment_id + '/';
			participant_url += client_id + '/';

			e.preventDefault();

			Adzuki.CustomConfirm({
				body   : client_name + ' has been set as the new Primary Client for the appointment. Would you like to send a new confirmation email to all clients for this appointment?',
				confirm: function confirm() {
					// send confirmation emails
					participant_url += '1';

					document.location =  Adzuki.base_uri + participant_url;
				},
				cancel: function cancel() {
					// set the primary but don't send the confirmation email(s)
					document.location =  Adzuki.base_uri + participant_url;
				}
			});
		});
	}
}(jQuery, window.Adzuki || {}));
